var map = {
	"./pages/protected/Apps/AppDetails/apps/Confluence/confluence.service.js": 6862,
	"./pages/protected/Apps/AppDetails/apps/Guru/guru.service.js": 363,
	"./pages/protected/Apps/AppDetails/apps/HappyFoxHelpdesk/happyfox-helpdesk.service.js": 5395,
	"./pages/protected/Apps/AppDetails/apps/Jira/jira.service.js": 7957,
	"./pages/protected/Apps/AppDetails/apps/Notion/notion.service.js": 2971,
	"./pages/protected/Apps/AppDetails/apps/OtherTicketingSystem/ots.service.js": 625,
	"./pages/protected/Apps/AppDetails/apps/SharePoint/sharepoint.service.js": 7250,
	"./pages/protected/Apps/AppDetails/apps/Simpplr/simpplr.service.js": 8817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1557;